<template>
  <div v-if="state != 'loading'">
    <b-alert variant="danger" v-if="deleted" show>
      <p>Empleado dado de baja el {{ this.deleted_at }}.</p>
      <p>Motivo: {{ this.deleted_reason }}</p>
    </b-alert>
    <b-alert
      variant="warning"
      v-if="employee.original_employee_id !== null"
      show
    >
      Este registro es una <strong>copia</strong> del original,
      <strong>solo editar detalles para nómina.</strong>
    </b-alert>
    <div class="justify-content-between align-items-center text-gray-700 mb-4 row">
      <span class="text-2xl text-ow-secondary font-weight-semibold col-md-4 col-sm-12">Información general del colaborador</span>
      <div class="justify-content-end flex-grow-1 col-md-8 col-sm-12">
        <div class="row">
          <div class="col-12 col-md-2 d-inline-flex p-1">
            <b-btn v-if="state == 'showing' && can('update', 'employees') && !deleted"
              class="btn-block align-items-center"
              @click="update"
              variant="outline-ow-secondary"
            >
              <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z">
                </path>
              </svg>
              <span>Editar</span>
            </b-btn>
          </div>
          <div class="col-12 col-md-3 d-inline-flex p-1" v-if="state == 'showing'">
            <b-button
              variant="outline-ow-primary"
              class="btn-block align-items-center justify-content-center"
              :href="`/benefits?allAreas=true&employee=${id}`"
            >
              <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z">
                </path>
              </svg>
              <span>Ver en Kardex</span>
            </b-button>
          </div>
          <div class="col-12 col-md-4 d-inline-flex p-1">
            <b-button v-if="state == 'showing' && can('delete', 'employees') && !deleted"
              class="btn-block align-items-center"
              variant="danger"
              v-b-modal.deleteConfirmation
            >
              <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7a4 4 0 11-8 0 4 4 0 018 0zM9 14a6 6 0 00-6 6v1h12v-1a6 6 0 00-6-6zM21 12h-6">
                </path>
              </svg>
              <span>Dar de baja al colaborador</span>
            </b-button>
          </div>
          <div class="col-12 col-md-3 d-inline-flex p-1">
            <b-button v-if="state == 'showing' && can('create', 'employees')" variant="ow-primary" @click="$emit('new-employee')" class="btn-block align-items-center justify-content-center">
              <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z">
                </path>
              </svg>
              <span>Alta de colaborador</span>
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <b-container fluid class="bg-white py-3 rounded shadow-sm">
      <div class="d-flex align-items-center">
        <b-row>
          <b-col xl="3" lg="3" md="3" sm="3" v-if="state == 'showing'">
            <div class="position-relative bottom-ribbon-container flex-shrink-0">
              <div class="position-relative">
                <div
                    v-if="employee.avatar_path || avatar"
                    class="position-relative d-flex justify-content-center align-items-center mx-auto rounded-circle avatar-container"
                    style="overflow: hidden"
                >
                  <b-img
                    rounded
                    fluid
                    :src="(avatar && avatarPreview) || employee.avatar_path"
                    alt="Avatar"
                  ></b-img>
                </div>
                <div class="text-center" v-else>
                  <img
                    v-if="employee.gender == 0"
                    src="/svg/male.svg"
                    class="img-fluid avatar-container"
                  />
                  <img
                    v-else
                    src="/svg/female.svg"
                    class="img-fluid avatar-container"
                  />
                </div>
                <!--  -->
                <b-form-file
                  v-model="avatar"
                  accept="image/*"
                  plain
                  ref="avatar"
                  id="avatar"
                  class="position-absolute w-100 h-100"
                  style="top: 0px; z-index: 2; opacity: 0"
                ></b-form-file>
              </div>
              <div class="text-center bottom-ribbon" v-if="!avatar" key="actions-1">
                <button
                  class="btn btn-small btn-link text-white"
                  v-if="employee.avatar_path"
                  v-b-modal.modal-avatar
                >
                  <font-awesome-icon icon="eye"></font-awesome-icon>
                </button>
                <label for="avatar"><font-awesome-icon icon="edit" class="text-white" /></label>
              </div>
              <small class="text-danger" v-if="!validAvatar">
                El archivo es muy grande para ser cargado.
              </small>
              <div v-if="avatar" class="mt-2 text-center" key="actions-2">
                <b-button
                  @click.prevent="upload"
                  :disabled="!validAvatar || loadingAvatar"
                  variant="primary"
                  size="sm"
                >
                  <font-awesome-icon icon="upload"></font-awesome-icon> Ok
                </b-button>
                <b-button
                  @click.prevent="emptyAvatar"
                  variant="danger"
                  size="sm"
                  :disabled="loadingAvatar"
                >
                  <font-awesome-icon icon="times"></font-awesome-icon> Cancelar
                </b-button>
              </div>
            </div>
          </b-col>
          <b-col :class="[state == 'showing' ? 'col-9' : 'col-12']" >
            <div class="flex-grow-1">
              <b-row>
                <b-col class="p-1" md="6" lg="4" xl="3" v-if="employee.code || state !== 'showing'">
                  <employee-code
                    type="text"
                    label="Número de colaborador"
                    :value="employee.code"
                    @input="updateEmployeeAttribute(['code', $event])"
                  ></employee-code>
                  <b-form-text
                    v-if="checkCode && state !== 'showing'"
                    class="warning"
                    id="inputLiveHelp"
                  >
                      El número de colaborador ya ha sido insertado anteriormente.
                  </b-form-text>
                </b-col>
                <b-col md="6" lg="4" xl="3" v-if="state === 'showing'" class="mb-2 p-1">
                  <span class="text-gray-700">Nombre:</span>
                  <span class="text-gray-700 d-flex align-items-center">
                <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2">
                  </path>
                </svg>
                <span class="font-weight-semibold">{{ employee.names }} {{ employee.first_surname }} {{ employee.second_surname }}</span>
              </span>
                </b-col>
                <b-col class="p-1" md="6" lg="4" xl="3" v-if="state !== 'showing'">
                  <employee-control
                    type="text"
                    :value="employee.names"
                    @input="updateEmployeeAttribute(['names', $event])"
                  >
                    <template #label>
                      <span class="d-flex align-items-center">
                        <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2">
                          </path>
                        </svg>
                        <span>Nombre</span>
                      </span>
                    </template>
                    <template #label-text="{ labelText, value }">
                  <span class="text-gray-700">
                    {{ labelText }}
                  </span>:
                      <span class="font-weight-semibold text-gray-700">{{ value }}</span>
                    </template>
                    <template #info>
                      <span class="text-danger">*</span> Este campo es obligatorio
                    </template>
                  </employee-control>
                </b-col>
                <b-col class="p-1" md="6" lg="4" xl="3" v-if="state !== 'showing'">
                  <employee-control
                    type="text"
                    :value="employee.first_surname"
                    @input="updateEmployeeAttribute(['first_surname', $event])"
                  >
                    <template #label>
                  <span class="d-flex align-items-center">
                    <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2">
                      </path>
                    </svg>
                    <span>Apellido paterno</span>
                  </span>
                    </template>
                    <template #label-text="{ labelText, value }">
                      <span class="text-gray-700">{{ labelText }}</span>:
                      <span class="font-weight-semibold text-gray-700">{{ value }}</span>
                    </template>
                  </employee-control>
                </b-col>
                <b-col class="p-1" md="6" lg="4" xl="3" v-if="state !== 'showing'">
                  <employee-control
                    type="text"
                    :value="employee.second_surname"
                    @input="updateEmployeeAttribute(['second_surname', $event])"
                  >
                    <template #label>
                  <span class="d-flex align-items-center">
                    <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2">
                      </path>
                    </svg>
                    <span>Apellido materno</span>
                  </span>
                    </template>
                    <template #label-text="{ labelText, value }">
                      <span class="text-gray-700">{{ labelText }}</span>:
                      <span class="font-weight-semibold text-gray-700">{{ value }}</span>
                    </template>
                  </employee-control>
                </b-col>
                <b-col class="p-1" md="6" lg="4" xl="3">
                  <employee-control
                    type="text"
                    :value="employee.alias"
                    @input="updateEmployeeAttribute(['alias', $event])"
                  >
                    <template #label>
                      <span class="d-flex align-items-center">
                        <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207">
                          </path>
                        </svg>
                        <span>Alias</span>
                      </span>
                    </template>
                    <template #label-text="{ labelText, value }">
                      <span class="text-gray-700">{{ labelText }}</span>
                      <div class="d-flex align-items-center text-gray-700">
                        <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207">
                          </path>
                        </svg>
                        <span class="font-weight-semibold">{{ value }}</span>
                      </div>
                    </template>
                  </employee-control>
                  <b-form-text
                    v-if="checkAlias && state !== 'showing'"
                    class="warning"
                    id="inputLiveHelp"
                  >El alias ya ha sido insertado anteriormente.</b-form-text>
                </b-col>
                <b-col class="p-1" md="6" lg="4" xl="3" v-if="state === 'showing'">
                  <div>
                    <span class="text-gray-700">Puesto: </span>
                    <div class="d-flex align-items-center text-gray-700">
                      <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z">
                        </path>
                      </svg>
                      <span class="font-weight-semibold">{{ puesto }}</span>
                    </div>
                  </div>
                </b-col>
                <b-col class="p-1" md="6" lg="4" xl="3" v-if="state === 'showing'">
                  <div v-if="can('view', 'salaries')">
                    <span class="text-gray-700">Salario: </span>
                    <div class="d-flex align-items-center text-gray-700">
                      <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z">
                        </path>
                      </svg>
                      <span class="font-weight-semibold">{{ salario }}</span>
                    </div>
                  </div>
                </b-col>
                <b-col class="p-1" md="6" lg="4" xl="3" v-if="state === 'showing'">
                  <div>
                    <span class="text-gray-700">Supervisores: </span>
                    <span class="font-weight-semibold text-gray-700">{{ supervisors }}</span>
                  </div>
                </b-col>
                <b-col class="p-1" md="6" lg="4" xl="3" v-if="false">
                  <b-button @click="moreInfo = !moreInfo" size="sm" variant="link"
                  >Más Información ...</b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
    <transition name="slide-fade">
      <b-card no-body class="mt-3 border-0 shadow-sm">
        <b-tabs small card>
          <b-tab title="Datos Personales">
            <b-row>
              <b-col :md="4">
                <employee-control
                  type="text"
                  label="RFC"
                  :value="employee.rfc"
                  @input="updateEmployeeAttribute(['rfc', $event])"
                ></employee-control>
              </b-col>
              <b-col :md="4">
                <employee-control
                  type="text"
                  label="Número de seguro social"
                  :value="employee.ssn"
                  @input="updateEmployeeAttribute(['ssn', $event])"
                ></employee-control>
              </b-col>
              <b-col :md="4">
                <employee-control
                  type="text"
                  label="CURP"
                  :value="employee.curp"
                  @input="updateEmployeeAttribute(['curp', $event])"
                ></employee-control>
              </b-col>
              <b-col :md="4">
                <employee-control
                  type="text"
                  label="Lugar de nacimiento"
                  :value="employee.birth_place"
                  @input="updateEmployeeAttribute(['birth_place', $event])"
                ></employee-control>
              </b-col>
              <b-col :md="4">
                <employee-control
                  type="date"
                  label="Fecha de nacimiento"
                  :value="employee.birthday"
                  @input="updateEmployeeAttribute(['birthday', $event])"
                >
                  <template #info>
                    <span class="text-danger">*</span> Este campo es obligatorio
                  </template>
                </employee-control>
              </b-col>
              <b-col :md="4">
                <employee-control
                  type="select"
                  label="Estado civil"
                  :options="maritalOptions"
                  :value="employee.marital_status"
                  @input="updateEmployeeAttribute(['marital_status', $event])"
                ></employee-control>
              </b-col>
              <b-col :md="4">
                <employee-control
                  type="select"
                  label="Género"
                  :options="genderOptions"
                  :value="employee.gender"
                  @input="updateEmployeeAttribute(['gender', $event])"
                ></employee-control>
              </b-col>
              <b-col :md="4">
                <employee-control
                  type="date"
                  label="Fecha de inicio laboral"
                  :value="employee.start_working_date"
                  @input="
                    updateEmployeeAttribute(['start_working_date', $event])
                  "
                >
                  <template #info>
                    <span class="text-danger">*</span> Este campo es obligatorio
                  </template>
                </employee-control>
              </b-col>
              <b-col :md="4">
                <employee-control
                  v-if="can('update', 'vacation_scheme')"
                  type="select"
                  label="Esquema de vacaciones (LFT)"
                  :options="vacationSchemeOptions"
                  :value="employee.vacation_scheme || 'lft_legacy'"
                  @input="updateEmployeeAttribute(['vacation_scheme', $event])"
                >
                  <template #info>
                    Tabla de días de vacaciones que se aplica a este colaborador.
                  </template>
                </employee-control>
                <div v-else>
                  <span class="text-gray-700">Esquema de vacaciones (LFT): </span>
                  <span class="font-weight-semibold">{{ vacationSchemeLabel }}</span>
                </div>
              </b-col>
              <b-col :md="4">
                <employee-control
                  label="Alergias"
                  :value="employee.allergies"
                  @input="updateEmployeeAttribute(['allergies', $event])"
                ></employee-control>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Información financiera">
            <b-row>
              <b-col :md="state === 'showing' ? 12 : 4">
                <employee-control
                  type="text"
                  label="Número de cuenta"
                  :value="employee.bank_account_number"
                  @input="updateEmployeeAttribute(['bank_account_number', $event])"
                ></employee-control>
              </b-col>
              <b-col :md="state === 'showing' ? 12 : 8">
                <employee-control
                  type="text"
                  label="CLABE"
                  :value="employee.clabe"
                  @input="updateEmployeeAttribute(['clabe', $event])"
                ></employee-control>
              </b-col>
              <b-col :md="state === 'showing' ? 12 : 8">
                <employee-control
                  type="text"
                  label="Banco"
                  :value="employee.bank"
                  @input="updateEmployeeAttribute(['bank', $event])"
                ></employee-control>
              </b-col>
              <b-col :md="state === 'showing' ? 12 : 4">
                <employee-control
                  type="select"
                  label="Moneda"
                  :options="currencies"
                  :value="employee.currency"
                  @input="updateEmployeeAttribute(['currency', $event])"
                ></employee-control>
              </b-col>
            </b-row>
          </b-tab>
          <div>
            <b-tab title="Contacto">
              <b-row>
                <b-col :md="4">
                  <employee-control
                    type="text"
                    label="Celular"
                    :value="employee.mobile_phone"
                    @input="updateEmployeeAttribute(['mobile_phone', $event])"
                  ></employee-control>
                </b-col>
                <b-col :md="4">
                  <employee-control
                    type="text"
                    label="Teléfono del colaborador"
                    :value="employee.work_telephone"
                    @input="updateEmployeeAttribute(['work_telephone', $event])"
                  ></employee-control>
                </b-col>
                <b-col :md="4">
                  <employee-control
                    type="text"
                    label="Teléfono de Casa"
                    :value="employee.home_telephone"
                    @input="updateEmployeeAttribute(['home_telephone', $event])"
                  ></employee-control>
                </b-col>
                <b-col :md="4">
                  <employee-control
                    type="email"
                    label="Correo electrónico personal"
                    :value="employee.other_email"
                    @input="updateEmployeeAttribute(['other_email', $event])"
                  ></employee-control>
                </b-col>
                <b-col :md="4">
                  <employee-control
                    type="email"
                    label="Correo electrónico del Trabajo"
                    :value="employee.work_email"
                    @input="updateEmployeeAttribute(['work_email', $event])"
                  ></employee-control>
                </b-col>
                <b-col :md="4">
                  <employee-control
                    type="text"
                    label="Calle 1"
                    :value="employee.street_1"
                    @input="updateEmployeeAttribute(['street_1', $event])"
                  ></employee-control>
                </b-col>
                <b-col :md="4">
                  <employee-control
                    type="text"
                    label="Calle 2"
                    :value="employee.street_2"
                    @input="updateEmployeeAttribute(['street_2', $event])"
                  ></employee-control>
                </b-col>
                <b-col :md="4">
                  <employee-control
                    type="text"
                    label="Ciudad"
                    :value="employee.city"
                    @input="updateEmployeeAttribute(['city', $event])"
                  ></employee-control>
                </b-col>
                <b-col :md="4">
                  <employee-control
                    type="text"
                    label="Código postal"
                    :value="employee.zip_code"
                    @input="updateEmployeeAttribute(['zip_code', $event])"
                  ></employee-control>
                </b-col>
                <b-col :md="4">
                  <employee-control
                    type="text"
                    label="Estado"
                    :value="employee.province"
                    @input="updateEmployeeAttribute(['province', $event])"
                  ></employee-control>
                </b-col>
                <b-col :md="4">
                  <employee-control
                    type="text"
                    label="País"
                    :value="employee.country"
                    @input="updateEmployeeAttribute(['country', $event])"
                  ></employee-control>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="Puestos">
              <b-alert variant="danger" v-if="groupNotFound" show dismissible>
                <p>
                  No se encontró un grupo de nómina para el puesto seleccionado.
                </p>
              </b-alert>
              <employments></employments>
            </b-tab>
            <b-tab title="Horarios">
              <schedules></schedules>
            </b-tab>
            <b-tab title="Supervisores" v-if="state !== 'creating'">
              <b-form-group>
                <supervisor-manager :employee="employee"></supervisor-manager>
              </b-form-group>
            </b-tab>
          </div>
          <b-tab title="Alta y baja del empleado">
            <div v-if="employee.movements && employee.movements.length > 0">
              <b-table :fields="movementsFields" :items="employee.movements">
              </b-table>
            </div>
            <div v-else>No hay movimientos por mostrar</div>
          </b-tab>
        </b-tabs>
      </b-card>
    </transition>
    <transition name="slide-fade">
      <b-card no-body class="mt-3 border-0 shadow-sm">
        <b-tabs small card>
          <div>
            <b-tab title="Contactos de emergencia">
              <emergency-contacts></emergency-contacts>
            </b-tab>
          </div>
          <div>
            <b-tab title="Educación">
              <education-records></education-records>
            </b-tab>
          </div>
          <div>
            <b-tab title="Evaluaciones">
              <quizzes></quizzes>
            </b-tab>
          </div>
          <template v-if="fileState !== ''">
            <b-tab title="Archivos">
              <files></files>
            </b-tab>
          </template>
          <!--div v-if="!deleted">
            <b-tab title="Salario">
              <base-salary></base-salary>
            </b-tab>
          </div-->
          <div>
            <div
              v-if="
                can('view', 'payroll_info') ||
                can('view', 'salaries') ||
                salaryState == 'creating' ||
                salariesCount == 0 ||
                salaryEdited > 0
              "
            >
              <!--            <div v-if="can('view', 'payroll_info') || can('view', 'salaries')">-->
              <b-tab title="Detalles para nomina">
                <!-- Detalles para nómina -->

                <b-card
                  v-if="isSaleMan || hasCancellingFund"
                  title="Fondo de cancelación"
                >
                  <cancelling-funds></cancelling-funds>
                </b-card>

                <div class="mt-3">
                  <p class="text-xl text-gray-800">Detalles para nómina</p>
                  <b-tabs pills vertical class="mt-3">
                    <b-tab
                      v-for="(payrollConfig, index) in employee.payrollConfigs"
                      :key="index"
                      :title="payrollConfig.group"
                    >
                      <employee-control
                        type="select"
                        label="Pagadora"
                        :value="payrollConfig.payer_id"
                        :options="payers"
                        @input="
                          updatePayrollConfigAttribute([
                            index,
                            'payer_id',
                            $event,
                          ])
                        "
                        v-if="can('view', 'payroll_info') && features['payers']"
                      ></employee-control>
                      <b-row>
                        <b-col>
                          <employee-control
                            type="select"
                            label="Estado"
                            :value="payrollConfig.status.id"
                            :options="status"
                            @input="
                              updatePayrollConfigStatus([index, 'id', $event])
                            "
                            v-if="can('view', 'payroll_info')"
                          ></employee-control>
                        </b-col>
                        <b-col>
                          <employee-control
                            type="date"
                            label="Desde"
                            :value="payrollConfig.status.effective_date"
                            @input="
                              updatePayrollConfigStatus([
                                index,
                                'effective_date',
                                $event,
                              ])
                            "
                            v-if="can('view', 'payroll_info')"
                          ></employee-control>
                        </b-col>
                      </b-row>

                      <employee-control
                        type="checkbox"
                        label="Vendedor"
                        :value="payrollConfig.sales_man"
                        @input="
                          updatePayrollConfigAttribute([
                            index,
                            'sales_man',
                            $event,
                          ])
                        "
                        v-if="can('view', 'payroll_info') && features['sales-rooms']"
                      ></employee-control>

                      <employee-control
                        type="checkbox"
                        v-if="payrollConfig.sales_man == 1 && features['sales-rooms']"
                        label="Vendedor administrativo"
                        :value="payrollConfig.administrative_sales_man"
                        @input="
                          updatePayrollConfigAttribute([
                            index,
                            'administrative_sales_man',
                            $event,
                          ])
                        "
                      ></employee-control>

                      <employee-control
                        type="checkbox"
                        label="Tiene fondo de cancelación"
                        :value="payrollConfig.has_cancelling_fund"
                        v-if="can('view', 'payroll_info') && features['sales-rooms']"
                        @input="
                          updatePayrollConfigAttribute([
                            index,
                            'has_cancelling_fund',
                            $event,
                          ])
                        "
                      ></employee-control>

                      <b-card>
                        <div slot="header">
                          <h6 class="mb-0 d-inline">Salario</h6>
                          <a
                            v-if="
                              (salaryState == 'show' &&
                                !deleted &&
                                (can('create', 'salaries') ||
                                  needs_payroll_info)) ||
                              salariesCount == 0 ||
                              salaryEdited > 0
                            "
                            class="float-right"
                            href="#"
                            @click.prevent="create(payrollConfig.id)"
                            >Agregar salario</a
                          >
                        </div>
                        <base-salary
                          :payroll-config="payrollConfig"
                        ></base-salary>
                      </b-card>

                      <b-card class="mt-3">
                        <div slot="header">
                          <h6 class="mb-0 d-inline">Bonos mensuales</h6>
                          <a
                            v-if="
                              (salaryState == 'show' &&
                                !deleted &&
                                (can('create', 'salaries') ||
                                  needs_payroll_info)) ||
                              salariesCount == 0 ||
                              salaryEdited > 0
                            "
                            class="float-right"
                            href="#"
                            @click.prevent="createFixedBonus(payrollConfig.id)"
                            >Agregar bono</a
                          >
                        </div>
                        <fixed-bonus
                          :payroll-config="payrollConfig"
                        ></fixed-bonus>
                      </b-card>

                      <!-- Must be deleted? -->
                      <!-- <b-card bg-card="light" class="mt-2 mb-2">
                        <b-form-group horizontal label="Clasificación para nóminas">
                          <employee-control label="Segmento" type="select" :options="payrollSegmentOptions" :value="payroll_segment_id" @input="updateEmployeeAttribute(['payroll_segment_id', $event])"></employee-control>
                          <employee-control label="Grupo" type="select" :options="payrollGroupOptions" :value="payroll_group_id" @input="updateEmployeeAttribute(['payroll_group_id', $event])"></employee-control>
                        </b-form-group>
                      </b-card> -->

                      <!-- Pending -->
                      <form
                        target="_blank"
                        v-if="
                          state == 'showing' && can('update', 'payroll_info')
                        "
                        :action="'employee-payroll/' + id"
                        method="GET"
                        class="form-inline mt-3"
                      >
                        <p class="mr-2">
                          Ir a pantalla de trabajo para nómina del:
                        </p>
                        <input
                          name="date"
                          type="date"
                          class="form-control mr-2"
                        />
                        <b-button type="submit" variant="info"
                          >Consultar</b-button
                        >
                      </form>

                      <b-card
                        v-if="can('update', 'payroll_info')"
                        bg-card="light"
                        class="mt-2 mb-2"
                      >
                        <div slot="header">
                          <h6 class="mb-0 d-inline">Descuentos fijos periódicos</h6>
                        </div>
                        <default-penalties
                          :payroll-config="payrollConfig"
                        ></default-penalties>
                      </b-card>

                      <employee-control
                        type="checkbox"
                        label="Recibe comisiones"
                        :value="payrollConfig.sales_man"
                        v-if="can('view', 'payroll_info')"
                        @input="
                          updatePayrollConfigAttribute([
                            index,
                            'sales_man',
                            $event,
                          ])
                        "
                        v-b-tooltip.hover
                        title="Recibirá comisiones, bono por parejas, override. Tendrá descuentos de fondo de cancelación"
                      ></employee-control>

                      <!-- Remove -->
                      <!-- <employee-control type="number" 
                        label="Monto del fondo de cancelación" 
                        :value="parseInt(employee.canceling_fund_limit)" 
                        @input="updateEmployeeAttribute(['canceling_fund_limit',$event])" 
                        v-if="employee.sales_man==1">
                      </employee-control> -->

                      <div
                        v-if="
                          (payrollConfig.sales_man == 1 &&
                            cancellingFundOptions.length > 0) ||
                          (payrollConfig.has_cancelling_fund == 1 &&
                            cancellingFundOptions.length > 0)
                        "
                      >
                        <b-row>
                          <b-col>
                            <employee-control
                              type="select"
                              label="Fondo de cancelación"
                              :options="cancellingFundOptions"
                              :value="payrollConfig.cancelling_fund_id"
                              @input="
                                updatePayrollConfigAttribute([
                                  index,
                                  'cancelling_fund_id',
                                  $event,
                                ])
                              "
                            ></employee-control>
                            <!--  <b-form-group horizontal label="Fonde de cancelación:" v-if="state == 'creating' || state == 'updating'">
                              <b-form-select :options="cancellingFundOptions" v-model="payrollConfig.cancelling_fund_id"></b-form-select>
                            </b-form-group>
                            <div v-else>
                              <span>Fonde de cancelación: </span>
                            </div> -->
                          </b-col>
                          <b-col>
                            <employee-control
                              type="number"
                              label="Descuento (%)"
                              :value="payrollConfig.cancelling_fund_discount"
                              @input="
                                updatePayrollConfigAttribute([
                                  index,
                                  'cancelling_fund_discount',
                                  $event,
                                ])
                              "
                            ></employee-control>
                            <!-- <b-form-group horizontal label="Descuento en fondo de cancelación" v-if="state == 'creating' || state == 'updating'">
                              <b-input-group append="%">
                                <b-form-input v-model="payrollConfig.cancelling_fund_discount"></b-form-input>
                              </b-input-group>
                            </b-form-group>
                            <div v-else>
                              <span>Descuento en fondo de cancelación: </span> {{ payrollConfig.discount_cancelling_fund }} %
                            </div> -->
                          </b-col>
                        </b-row>
                      </div>

                      <b-card
                        v-if="
                          can('update', 'payroll_info') &&
                          payrollConfig.sales_man == 1
                        "
                        bg-card="light"
                        class="mt-2 mb-2"
                      >
                        <b-form-group
                          horizontal
                          label="Reglas de cobro de comisión"
                        >
                          <commission-rules-group
                            :payroll-config="payrollConfig"
                          ></commission-rules-group>
                        </b-form-group>
                      </b-card>

                      <b-card
                        v-if="
                          can('update', 'payroll_info') &&
                          payrollConfig.sales_man == 1
                        "
                        bg-card="light"
                        class="mt-2 mb-2"
                      >
                        <b-form-group
                          horizontal
                          label="Reglas de cobro de parejas"
                        >
                          <qs-payment-rules-group
                            :payroll-config="payrollConfig"
                          ></qs-payment-rules-group>
                        </b-form-group>
                      </b-card>

                      <b-card
                        v-if="
                          can('update', 'payroll_info') &&
                          payrollConfig.sales_man == 1
                        "
                        bg-card="light"
                        class="mt-2 mb-2"
                      >
                        <b-form-group horizontal label="Niveles de comisión">
                          <commission-levels
                            :payroll-config="payrollConfig"
                          ></commission-levels>
                        </b-form-group>
                      </b-card>
                    </b-tab>
                  </b-tabs>
                </div>
                <!-- End detalles para nómina -->
              </b-tab>
            </div>
          </div>
          <div v-if="can('view', 'salaries')">
            <b-tab title="Historico salario">
              <salary-history> </salary-history>
            </b-tab>
          </div>
        </b-tabs>
      </b-card>
    </transition>

    <b-button
      v-if="state == 'showing' && can('create', 'employees') && deleted"
      class="float-right"
      variant="info"
      v-b-modal.reactivateConfirmation
    >
      Volver a dar de alta empleado
    </b-button>
    <b-modal
      id="reactivateConfirmation"
      ref="reactivationInformationModal"
      ok-title="Si, dar de alta"
      cancel-title="Cancelar"
      ok-variant="info"
      @ok="reactivateEmployee"
    >
      <p>¿Seguro que quieres reactivar a este empleado?</p>
      <b-form>
        <b-form-group
          id="reactivationInformationDateGroup"
          label="Fecha de de reingreso:"
          label-for="reactivationInformationDate"
          description="*Campo obligatorio. Fecha en la que reingresara el colaborador."
        >
          <b-form-input
            id="reactivationInformationDate"
            type="date"
            :state="isValidReactivationInformation"
            v-model="reactivationInformation.date"
          >
          </b-form-input>
        </b-form-group>
        <b-form-group
          id="reactivationInformationNewSalaryGroup"
          label="Nuevo salario"
          label-for="reactivationInformationNewSalary"
          description="Nuevo salario a partir de la fecha de reingreso, si no se ingresa, se tomará salario anterior"
        >
          <b-form-input
            id="reactivationInformationNewSalary"
            type="number"
            v-model="reactivationInformation.newSalary"
          ></b-form-input>
        </b-form-group>

        <b-form-textarea
          id="reactivationInformationNote"
          v-model="reactivationInformation.note"
          placeholder="Notas de salario"
        ></b-form-textarea>
      </b-form>
    </b-modal>

    <b-modal
      id="deleteConfirmation"
      ok-title="Si, dar de baja"
      cancel-title="Cancelar"
      ok-variant="danger"
      @ok="deleteEmployee"
    >
      <p>¿Seguro que quieres dar de baja a este empleado?</p>
      <p>Fecha de baja:</p>
      <b-form-input v-model="deletedDate" type="date"></b-form-input>
      <b-form-textarea
        v-model="deletedReason"
        rows="5"
        placeholder="Escribe el motivo de la baja"
      ></b-form-textarea>
    </b-modal>

    <b-modal id="modal-avatar" hide-header ok-only>
      <b-img fluid :src="employee.avatar_path" alt="Avatar"></b-img>
    </b-modal>
  </div>
  <div v-else>
    <h3>Cargando...</h3>
  </div>
</template>
<script>
import FontAwesomeIcon from "@fortawesome/vue-fontawesome";
import fontawesome from "@fortawesome/fontawesome";
import faEdit from "@fortawesome/fontawesome-free-solid/faEdit";
import faUpload from "@fortawesome/fontawesome-free-solid/faUpload";
import faTimes from "@fortawesome/fontawesome-free-solid/faTimes";
import faEye from "@fortawesome/fontawesome-free-solid/faEye";
fontawesome.library.add(faEdit, faUpload, faTimes, faEye);

import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import EmployeeControl from "./EmployeeManager/EmployeeControl.vue";
import BaseSalary from "./EmployeeManager/BaseSalary.vue";
import Loans from "./EmployeeManager/Loans.vue";
import EmergencyContacts from "./EmployeeManager/EmergencyContacts.vue";
import EducationRecords from "./EmployeeManager/EducationRecords.vue";
import DefaultPenalties from "./EmployeeManager/DefaultPenalties.vue";
import Files from "./EmployeeManager/Files.vue";
import Employments from "./EmployeeManager/JobTitles.vue";
import CommissionRulesGroup from "./EmployeeManager/CommissionRulesGroup.vue";
import QsPaymentRulesGroup from "./EmployeeManager/QsPaymentRulesGroup.vue";
import CommissionLevels from "./EmployeeManager/CommissionLevels.vue";
import SupervisorManager from "./EmployeeManager/SupervisorsManager.vue";
import CancellingFunds from "./EmployeeManager/CancellingFunds";
import SalaryHistory from "./EmployeeManager/SalaryHistory";
import FixedBonus from "./EmployeeManager/FixedBonus.vue";
import Quizzes from "./EmployeeManager/Quizzes.vue";
import EmployeeCode from "./EmployeeManager/EmployeeCode.vue";
import Schedules from "./EmployeeManager/Schedules.vue";

import { Validation, moneyString } from "../utils";

export default {
  props: {
    initialEmployee: {
      type: Number,
      default: null
    }
  },
  components: {
    BaseSalary,
    Loans,
    DefaultPenalties,
    EmployeeControl,
    EmergencyContacts,
    EducationRecords,
    Files,
    Employments,
    CommissionRulesGroup,
    CommissionLevels,
    QsPaymentRulesGroup,
    SupervisorManager,
    FontAwesomeIcon,
    CancellingFunds,
    SalaryHistory,
    FixedBonus,
    Quizzes,
    EmployeeCode,
    Schedules,
  },
  computed: {
    ...mapState({
      features: (state) => state.employeeManager.features,
      employee: (state) => state.employeeManager.employee,
      employeeCode: (state) => state.employeeManager.employee.code,
      employeeAlias: (state) => state.employeeManager.employee.alias,
      id: (state) => state.employeeManager.employee.id,
      payroll_group_id: (state) =>
        state.employeeManager.employee.payroll_group_id,
      payroll_segment_id: (state) =>
        state.employeeManager.employee.payroll_segment_id,
      state: (state) => state.employeeManager.state,
      fileState: (state) => state.employeeManager.fileState,
      permissions: (state) => state.employeeManager.employee.permissions,
      deleted_at: (state) => state.employeeManager.employee.deleted_at,
      deleted_reason: (state) => state.employeeManager.employee.deleted_reason,
      needs_payroll_info: (state) =>
        state.employeeManager.employee.needs_payroll_info,
      salaryState: (state) => state.employeeManager.salaryState,
      salariesCount: (state) => {
        return state.employeeManager.employee.payrollConfigs.reduce(
          (acc, pc) => {
            return acc + pc.salaries.length;
          },
          0
        );
      },
    }),
    ...mapGetters({
      isSaleMan: "isSaleMan",
      hasCancellingFund: "hasCancellingFund",
      cancellingFundOptions: "cancellingFundOptions",
      salaryEdited: "salaryEdited",
    }),
    puesto() {
      if (this.employee.jobTitles.length > 0)
        return this.employee.jobTitles[this.employee.jobTitles.length - 1].name;
      return "";
    },
    supervisors() {
      if (this.employee.supervisors.length > 0)
        return this.employee.supervisors.map((s) => s.names).join(", ");
      return "";
    },
    salario() {
      if (this.employee.payrollConfigs.length) {
        let pc = this.employee.payrollConfigs[this.employee.payrollConfigs.length -1];
        if(pc.salaries.length)
            return pc.salaries[pc.salaries.length-1].amount || 0;
      }

      return "";
    },
    groupNotFound() {
      console.log("This is the state");
      console.log(this.$store.state);
      //return true;
      return this.$store.state.employeeManager.payrollGroupNotFound;
    },
    icon: () => faCoffee,
    maritalOptions: () => [
      { value: "single", text: "Soltero" },
      { value: "married", text: "Casado" },
    ],
    genderOptions: () => [
      { value: true, text: "Mujer" },
      { value: false, text: "Hombre" },
    ],
    vacationSchemeOptions: () => [
      { value: "lft_legacy", text: "LFT anterior" },
      { value: "lft_2023", text: "LFT vigente" },
    ],
    vacationSchemeLabel() {
      var option = this.vacationSchemeOptions.find(
        (o) => o.value === this.employee.vacation_scheme
      );
      return option ? option.text : "Predeterminado del sistema";
    },
    payrollSegmentOptions: () =>
      [{ value: null, text: "Sin segmento" }].concat(
        payrollSegments.map((s) => {
          return { value: s.id, text: s.name };
        })
      ),
    payrollSegment() {
      if (this.payroll_segment_id === null) return null;
      return payrollSegments.find((s) => s.id == this.payroll_segment_id);
    },
    payrollGroupOptions() {
      var os = [];
      if (this.payrollSegment === null) os = [];
      else
        os = this.payrollSegment.groups.map((g) => {
          return { value: g.id, text: g.name };
        });
      return os.concat([{ value: null, text: "Sin grupo" }]);
    },
    payers() {
      return this.$store.state.employeeManager.payers.map((c) => {
        return { text: c.name, value: c.id };
      });
    },
    status() {
      return this.$store.state.employeeManager.status.map((c) => {
        return { text: c.status, value: c.id };
      });
    },
    currencies() {
      return this.$store.state.employeeManager.currencies.map((c) => {
        return { text: c, value: c };
      });
    },
    deleted() {
      return this.deleted_at !== null;
    },
    movementsFields() {
      return [
        {
          key: 'date',
          label: "Fecha",
        },
        {
          key: 'type',
          label: "Tipo de movimiento",
        },
      ];
    },
    isValidReactivationInformation() {
      return (
        this.reactivationInformation.date !== null &&
        this.reactivationInformation.date !== ""
      );
    },
    avatarPreview() {
      if (this.avatar) {
        console.log(this.avatar);
        return URL.createObjectURL(this.avatar);
      }

      return null;
    },
    validAvatar() {
      if (this.avatar) {
        return this.avatar.size / 1024 < 2000;
      }

      return true;
    },
  },
  mounted() {
    this.avatar = null;
    if (this.initialEmployee) {
      this.getAndShowEmployee(this.initialEmployee);
    }
  },
  methods: {
    can: (action, resource) => {
      if (permissions === null) return false;
      if (typeof permissions[resource] === "undefined") return false;
      return permissions[resource].includes(action);
    },
    toogleMoreInfo() {
      this.moreInfo = !this.moreInfo;
    },
    ...mapMutations({
      updateEmployeeAttribute: "updateEmployeeAttribute",
      update: "updating",
      updateEmployeeStatus: "updateEmployeeStatus",
      updatePayrollConfigAttribute: "updatePayrollConfigAttribute",
      updatePayrollConfigStatus: "updatePayrollConfigStatus",
      create: "creatingSalary",
      createFixedBonus: "creatingFixedBonus",
    }),
    ...mapActions({
      delete: "deleteEmployee",
      reactivate: "reactivateEmployee",
      getAndShowEmployee: "getAndShowEmployee",
    }),
    reactivateEmployee(e) {
      e.preventDefault();

      if (this.isValidReactivationInformation) {
        this.$refs.reactivationInformationModal.hide();
        this.reactivate({
          employeeId: this.$store.state.employeeManager.employee.id,
          date: this.reactivationInformation.date,
          newSalary: this.reactivationInformation.newSalary,
          note: this.reactivationInformation.note,
        });
      }
    },
    deleteEmployee() {
      this.delete({
        employee: this.$store.state.employeeManager.employee.id,
        reason: this.deletedReason,
        date: this.deletedDate,
      });
      this.deletedReason = "";
    },
    /*    canUpdate(resource){
      return this.permissions[resource].includes('update')
    },
    canDelete(resource){
      return this.permissions[resource].includes('delete')
    }*/
    async upload() {
      this.loadingAvatar = true;
      let form = new FormData();
      form.append("avatar", this.avatar);

      let { data } = await axios.post(`/employees/${this.id}/avatar`, form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      this.avatar = null;
      this.loadingAvatar = false;
      this.getAndShowEmployee(this.id);
    },
    emptyAvatar() {
      this.$refs["avatar"].reset();
    },
  },
  data() {
    return {
      deletedReason: "",
      deletedDate: "",
      moreInfo: false,
      checkCode: false,
      checkAlias: false,
      reactivationInformation: {
        date: null,
        newSalary: null,
        note: "",
      },
      payrollGroupNotFound: false,
      avatar: null,
      loadingAvatar: false,
    };
  },
  watch: {
    employeeCode(code) {
      var id = this.employee.id || 0;
      axios
        .get("/employees/exists", { params: { code, id } })
        .then((res) => {
          this.checkCode = res.data;
        })
        .catch((res) => {
          console.log(res);
        });
    },
    employeeAlias(alias) {
      var id = this.employee.id || 0;
      axios
        .get("/employees/exists", { params: { alias, id } })
        .then((res) => {
          this.checkAlias = res.data;
        })
        .catch((res) => {
          console.log(res);
        });
    },
  },
};
</script>
<style>
.warning {
  color: #eaa911 !important;
}
.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.6s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.bottom-ribbon-container {
  overflow: hidden;
}
.bottom-ribbon {
  position: absolute;
  bottom: 0px;
  left: 0px;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  z-index: 5;
  transform: translateY(38px);
  transition: all 0.36s;
}
.bottom-ribbon-container:hover .bottom-ribbon {
  display: block;
  transform: translate(0);
}
</style>
